import { createApiRef } from '@backstage/core-plugin-api';

export interface Option {
	name: string;
	id: string;
	selfLink: string;
}

export interface CloudProvidersApi {
	getHealth(): Promise<{ status: string; }>;
	getOrganizations(params: any): Promise<Option[]>
	getProjects(params: any): Promise<Option[]>
	getNetworks(params: any): Promise<Option[]>
	getSubNetworks(params: any): Promise<Option[]>
	getGithubDirectories(params: any): Promise<Option[]>

}

export const cloudProvidersApiRef = createApiRef<CloudProvidersApi>({
	id: 'plugin.cloud-providers.service',
});